import { Divider as ChakraDivider } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type DividerProps = ComponentPropsWithRef<typeof ChakraDivider>;

export function Divider(props: DividerProps) {
  return <ChakraDivider {...props} />;
}
